/*
 * ap-cart-companion.js — Verhalten des Montagecheck-Panels im Warenkorb.
 *
 * Zwei Aufgaben, beide bewusst ohne eigene Warenkorb-Logik:
 *
 *   1. Der Knopf "Auf 2 erhoehen" schreibt in das MENGENFELD der Position und
 *      loest dort ein change-Ereignis aus. Damit laeuft die Aenderung durch
 *      exakt denselben Pfad wie ein Klick auf "+" (cart.js validateQuantity ->
 *      updateQuantity): Bestandspruefung, Ladezustand, Fehlermeldung und
 *      Section-Neuaufbau kommen unveraendert vom Theme. Es gibt hier
 *      absichtlich KEINEN eigenen /cart/change-Aufruf.
 *
 *   2. Die Kartenzeile "Passend dazu" wird beim ersten Oeffnen des Drawers
 *      ueber ?section_id=ap-cart-suggest nachgeladen. Sie steht deshalb nicht
 *      im Drawer-Markup: der Drawer liegt im Layout jeder Seite, und
 *      Bildkarten fuer sechs Produkte auf jedem Seitenaufruf waeren Renderzeit
 *      fuer nichts. Es gibt ZWEI Zielcontainer fuer denselben Inhalt — das
 *      Begleit-Panel (>= 1100px) und die Reihe im scrollenden Drawer-Bereich
 *      (darunter). EIN Abruf befuellt beide; welcher sichtbar ist, entscheidet
 *      allein das CSS (ap-cart-companion.css, Abschnitte 1 und 8).
 */

(function () {
  'use strict';

  var SUGGEST = '[data-ap-cartc-suggest]';

  /* ===================================================================== *
   * 1. MENGEN-KNOPF
   * ===================================================================== */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var button = target.closest('[data-ap-cartc-qty]');
    if (!button) return;

    var quantity = parseInt(button.dataset.apCartcQty, 10);
    var line = button.dataset.apCartcLine;
    if (!quantity || !line) return;

    // Auf der Warenkorbseite (Modus 'page', sections/main-cart-items.liquid)
    // gehoert der Knopf zum Mengenfeld DER SEITE (Quantity-N): das Feld der
    // Schublade (Drawer-quantity-N, liegt auch auf /cart im Layout) wuerde nur
    // die Schublade neu zeichnen — cart.js ignoriert deren Rundruf auf der Seite.
    var onPage = !!button.closest('.ap-cartc__check--page');
    var input = document.getElementById((onPage ? 'Quantity-' : 'Drawer-quantity-') + line);
    if (!input) return;

    // Doppelklick waehrend des laufenden Updates verhindern. Im Normalfall
    // verschwindet der Knopf gleich mit dem Section-Neuaufbau.
    if (button.getAttribute('aria-disabled') === 'true') return;
    button.setAttribute('aria-disabled', 'true');
    // NICHT Dawns .loading: diese Klasse setzt color: transparent und erwartet
    // einen .loading__spinner als Ersatz. Dieser Knopf hat keinen — uebrig
    // blieb ein leerer Knopf ohne Beschriftung.
    button.classList.add('is-busy');
    // KEIN Neuaufbau = der Knopf bliebe fuer immer gesperrt (26.09.2026):
    // lehnt cart.js die Menge ab (validateQuantity: Maximum/Schrittmass) oder
    // meldet /cart/change einen Fehler, wird die Section nicht neu gezeichnet,
    // und jeder weitere Klick endete stumm oben im aria-disabled-Riegel. Die
    // Meldung selbst zeigt cart.js am Mengenfeld bzw. an der Position; hier
    // wird der Knopf nach der Laufzeit wieder freigegeben, falls er noch steht.
    window.setTimeout(function () {
      if (!button.isConnected) return;
      button.removeAttribute('aria-disabled');
      button.classList.remove('is-busy');
    }, 4000);

    input.value = quantity;
    // Muss aufsteigen: der Zuhoerer haengt an <cart-drawer-items>, nicht am Feld.
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ===================================================================== *
   * 2. STATUSZEILE -> SPRUNG ZUR PRUEFLISTE
   * Auf schmalen Bildschirmen steht die Liste unter den Positionen im
   * scrollenden Bereich; die feste Zeile oben bringt den Kunden mit einem
   * Tipp dorthin. Bewusst kein Aufklappen (der obere Streifen kann nicht
   * schrumpfen und haette den Kaufknopf verdraengt) und kein Modal (der
   * Drawer ist bereits ein Dialog, Dawns Fokusfalle stapelt nicht).
   * ===================================================================== */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    if (!target.closest('[data-ap-cartc-jump]')) return;

    var list = document.getElementById('ApCartCheckList');
    if (!list) return;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // 'start' statt 'nearest': liegt die Liste ohnehin schon im Bild, bewegt
    // sich bei 'nearest' NICHTS — der Tipp sah dann aus, als taete er nichts.
    list.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });

    // Zusaetzlich kurz hervorheben: das ist die Rueckmeldung fuer den Fall,
    // dass gar nicht gescrollt werden muss.
    list.classList.remove('is-jumped');
    // Erzwungenes Neuberechnen, sonst startet die Animation beim zweiten Tipp
    // nicht noch einmal.
    void list.offsetWidth;
    list.classList.add('is-jumped');
  });

  /* ===================================================================== *
   * 3. KARTENZEILE NACHLADEN
   * ===================================================================== */
  function cartUrl() {
    var routes = window.routes || {};
    return routes.cart_url || '/cart';
  }

  function suggestHosts() {
    return Array.prototype.slice.call(document.querySelectorAll(SUGGEST));
  }

  /*
   * EIN ABRUF JE WARENKORB-AENDERUNG (26.09.2026). Mitgeschnitten kam die
   * Zeile je Klick 4–6-mal (Rundruf, Austausch des Drawer-Inhalts, Oeffnen,
   * Einsetzen der Antwort — jeder Ausloeser startete seinen eigenen Abruf).
   * Das trieb die Anfragen je Klick auf 8–11 und liess Shopifys Bot-Schutz
   * anschlagen. Jetzt:
   *   - Ausloeser im selben Atemzug (Beobachter + Rundruf) werden zu EINEM
   *     Laden zusammengefasst (Mikrotask);
   *   - laeuft schon ein Abruf, startet kein zweiter — seine Antwort befuellt
   *     auch die inzwischen neuen Knoten;
   *   - kam WAEHREND des Abrufs ein Rundruf (der Korb hat sich geaendert),
   *     ist die Antwort veraltet: danach genau ein Nachabruf;
   *   - ein Rundruf mit schubladeFrisch (window.ApCartAdd.kauf hat die
   *     Schublade gerade aus der Antwort gezeichnet) loest KEINEN eigenen
   *     Abruf aus: die neuen Knoten tragen keine Marke, der Beobachter laedt
   *     sie ohnehin. Nur ein Abruf, der noch fuer die ALTEN Knoten lief, ist
   *     dann veraltet.
   */
  var rundruf = false; // cartUpdate ist abonniert (pubsub.js geladen)
  var laufend = false;
  var veraltet = false;
  var geplant = false;
  var laufendeHosts = [];

  function planeLaden() {
    if (geplant) return;
    geplant = true;
    Promise.resolve().then(function () {
      geplant = false;
      loadSuggest();
    });
  }

  function loadSuggest() {
    var hosts = suggestHosts();
    if (!hosts.length) return;

    var pending = hosts.some(function (host) {
      return host.dataset.apCartcLoaded !== '1';
    });
    if (!pending) return;
    if (laufend) return;

    // Die Markierung steht VOR dem Abruf: sie verhindert nicht nur den
    // Doppelabruf, sondern auch eine Endlosschleife — das Einsetzen des
    // Ergebnisses loest denselben MutationObserver aus, der uns hierher
    // gebracht hat.
    laufend = true;
    veraltet = false;
    laufendeHosts = hosts;
    hosts.forEach(function (host) {
      host.dataset.apCartcLoaded = '1';
    });

    fetch(cartUrl() + '?section_id=ap-cart-suggest')
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var body = doc.querySelector('[data-ap-cartc-suggest-body]');
        // Die Zielknoten FRISCH aufloesen statt der Closure-Referenzen:
        // waehrend der Abruf lief, kann renderContents den Drawer-Inhalt
        // ausgetauscht haben. Die Antwort landete dann in abgehaengten
        // Knoten — die sichtbaren neuen blieben leer.
        //
        // Die Ladenmarkierung: Mit Rundruf entscheidet er, ob die Antwort
        // noch den aktuellen Korb zeigt (kein Rundruf waehrend des Abrufs ->
        // alle Knoten gelten als geladen, auch getauschte). OHNE Rundruf
        // (boot() toleriert ein fehlendes pubsub.js) behalten sie NUR
        // unveraendert gebliebene Hosts: ein getauschter Knoten bekommt den
        // Inhalt (besser als leer), aber KEINE Marke — so laedt der
        // MutationObserver-Pfad beim naechsten sync() frisch nach.
        suggestHosts().forEach(function (el) {
          el.innerHTML = body ? body.innerHTML : '';
          var aktuell = rundruf ? !veraltet : hosts.indexOf(el) !== -1;
          if (!aktuell) el.dataset.apCartcLoaded = '';
          else if (rundruf) el.dataset.apCartcLoaded = '1';
        });
      })
      .catch(function () {
        // Ohne Antwort bleibt der Container leer — die :empty-Regel in
        // ap-cart-companion.css blendet die Zeile dann aus.
        suggestHosts().forEach(function (el) {
          el.innerHTML = '';
        });
      })
      .then(function () {
        laufend = false;
        if (veraltet) {
          veraltet = false;
          planeLaden();
        }
      });
  }

  /*
   * Nach einer Warenkorb-Aenderung sind die Vorschlaege veraltet — aber der
   * ALTE Inhalt bleibt sichtbar, bis die Antwort da ist. Genau das verhindert
   * das Springen: kein Zwischenzustand, in dem die Zeile leer ist, die
   * :empty-Regel sie ausblendet und das Raster kurz auf eine Spalte faellt.
   */
  function refreshSuggest(daten) {
    var hosts = suggestHosts();
    if (!hosts.length) return;
    if (daten && daten.schubladeFrisch) {
      var fremd = hosts.some(function (host) {
        return laufendeHosts.indexOf(host) === -1;
      });
      if (laufend && fremd) veraltet = true;
      return;
    }
    hosts.forEach(function (host) {
      host.dataset.apCartcLoaded = '';
    });
    if (laufend) veraltet = true;
    planeLaden();
  }

  function boot() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    // Der Warenkorb-Rundruf des Themes ist die verlaessliche Quelle dafuer,
    // dass sich am Inhalt wirklich etwas geaendert hat. typeof-Pruefung, weil
    // pubsub.js seine Namen per const im Skript-Bereich anlegt (nicht an
    // window) — fehlt die Datei, laeuft alles Uebrige trotzdem weiter.
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, refreshSuggest);
        rundruf = true;
      }
    } catch (e) {
      /* Rundruf nicht verfuegbar — die Zeile bleibt dann bis zum naechsten
         Seitenaufruf stehen, statt gar nicht zu erscheinen. */
    }

    function sync() {
      if (!drawer.classList.contains('active')) return;
      planeLaden();
    }

    // Drei Ausloeser in einem Beobachter:
    //   - class-Wechsel  -> der Drawer wird geoeffnet,
    //   - childList/subtree -> das Panel wurde nach einer Warenkorb-Aenderung
    //     ausgetauscht und traegt die Ladermarkierung nicht mehr.
    new MutationObserver(sync).observe(drawer, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true,
    });

    // Beim Start ohne Umweg: ist die Schublade schon offen, sofort laden.
    if (drawer.classList.contains('active')) loadSuggest();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
